@if (showCover) {
  <a pxNamedRouterLink="CATALOG_BIB_DETAILS" [pxNamedRouterLinkParams]="{id: catalogRecord.id}">
    <mx-cover-image [catalogRecord]="catalogRecord" [widthRem]="2.5" [heightRem]="2.5"/>
  </a>
}
<div class="grow min-w-0">
  <mx-link-button [label]="catalogRecord.title" linkType="inline" [truncateMaxLines]="titleMaxLines" routeName="CATALOG_BIB_DETAILS"
                  [routeParams]="{id: catalogRecord.id}" labelClasses="text-title-medium" class="w-full"/>
  @if (isDefined(detail1)) {
    <p [ngClass]="detailTextSizeClasses">{{ detail1 | format: 'REPLACE_EMPTY' }}</p>
  }
  @if (isDefined(detail2)) {
    <p [ngClass]="detailTextSizeClasses">{{ detail2 | format: 'REPLACE_EMPTY' }}</p>
  }
  @if (isDefined(date1Label) && isDefined(date1)) {
    <p class="text-body-medium md:text-body-small">
      {{ date1Label }}: <span [class.text-error]="date1Error">{{ date1 | format: ['DATE_ONLY', 'REPLACE_EMPTY'] }}</span>
    </p>
  }
  @if (isDefined(date2Label) && isDefined(date2)) {
    <p class="text-body-medium md:text-body-small">{{ date2Label }}: {{ date2 | format: ['DATE_ONLY', 'REPLACE_EMPTY'] }}</p>
  }
</div>
